import React, { Component, Fragment } from 'react';
import ReactLazyLoad from 'react-lazyload';
import { forceCheck } from 'react-lazyload';

// This is a simple component to wrap the third-party LazyLoad component
// https://github.com/jasonslyvia/react-lazyload
// This _should_ make it easier if we decide to switch to another third-party
// component later or write our own, i.e. no need to change imports (although
// the API might change)
class LazyLoad extends Component {
  static runForceCheck = forceCheck;
  render() {
    return (
      <Fragment>
        <ReactLazyLoad {...this.props} />
      </Fragment>
    );
  }
}

LazyLoad.defaultProps = ReactLazyLoad.defaultProps;

LazyLoad.propTypes = ReactLazyLoad.propTypes;

export default LazyLoad;
